<template>
  <div class="page-board">
    <template v-if="!loading && !isError">
      <section class="section">
        <h3 class="tit-h3">
          처리 필요
        </h3>
        <ul class="board">
          <li class="board-class blue">
            <h4 class="board-tit">
              생성
            </h4>
            <div class="board-col">
              <board-state
                title="플랜 생성 대기"
                :count="requests['CREATED_REQUEST_PLAN']?.length || 0"
              >
                <board-state-item
                  v-for="(request, index) in requests.CREATED_REQUEST_PLAN"
                  :key="index"
                  status="CREATED_REQUEST_PLAN"
                  :data="request"
                />
              </board-state>
            </div>
            <div class="board-col">
              <board-state
                title="PV 충전 대기"
                :count="requests['CREATED_REQUEST_PV']?.length || 0"
              >
                <board-state-item
                  v-for="(request, index) in requests.CREATED_REQUEST_PV"
                  :key="index"
                  status="CREATED_REQUEST_PV"
                  :data="request"
                />
              </board-state>
              <board-state
                title="JAM 충전 대기"
                :count="requests['CREATED_REQUEST_JAM']?.length || 0"
              >
                <board-state-item
                  v-for="(request, index) in requests.CREATED_REQUEST_JAM"
                  :key="index"
                  status="CREATED_REQUEST_JAM"
                  :data="request"
                />
              </board-state>
              <board-state
                title="부가 서비스 처리 대기"
                :count="requests['CREATED_REQUEST_ADDITIONAL']?.length || 0"
              >
                <board-state-item
                  v-for="(request, index) in requests.CREATED_REQUEST_ADDITIONAL"
                  :key="index"
                  status="CREATED_REQUEST_ADDITIONAL"
                  :data="request"
                />
              </board-state>
            </div>
          </li>
          <li class="board-class purple">
            <h4 class="board-tit">
              결제
            </h4>
            <div class="board-col">
              <board-state
                title="무통장 입금 대기"
                :count="requests['DAY_PAYMENT_WIRE']?.length || 0"
              >
                <board-state-item
                  v-for="(request, index) in requests.DAY_PAYMENT_WIRE"
                  :key="index"
                  status="DAY_PAYMENT_WIRE"
                  :data="request"
                />
              </board-state>
              <board-state
                title="무통장 입금 지연"
                :count="requests['DAY_PAYMENT_WIRE_DELAY']?.length || 0"
              >
                <board-state-item
                  v-for="(request, index) in requests.DAY_PAYMENT_WIRE_DELAY"
                  :key="index"
                  status="DAY_PAYMENT_WIRE_DELAY"
                  :data="request"
                />
              </board-state>
            </div>
            <div class="board-col">
              <board-state
                title="카드 결제 대기"
                :count="requests['DAY_PAYMENT_CARD']?.length || 0"
              >
                <board-state-item
                  v-for="(request, index) in requests.DAY_PAYMENT_CARD"
                  :key="index"
                  status="DAY_PAYMENT_CARD"
                  :data="request"
                />
              </board-state>
            </div>
          </li>
          <li class="board-class pink">
            <h4 class="board-tit">
              서류 발행
            </h4>
            <div class="board-col">
              <board-state
                title="세금 계산서"
                :count="requests['DAY_INVOICE_TAX']?.length || 0"
              >
                <board-state-item
                  v-for="(request, index) in requests.DAY_INVOICE_TAX"
                  :key="index"
                  status="DAY_INVOICE_TAX"
                  :data="request"
                />
              </board-state>
            </div>
            <div class="board-col">
              <board-state
                title="기타 서류"
                :count="requests['DAY_INVOICE']?.length || 0"
              >
                <board-state-item
                  v-for="(request, index) in requests.DAY_INVOICE"
                  :key="index"
                  status="DAY_INVOICE"
                  :data="request"
                />
              </board-state>
            </div>
          </li>
          <li class="board-class rose">
            <h4 class="board-tit">
              연장
            </h4>
            <board-state
              title="플랜 연장 필요"
              :count="requests['NEED_TO_EXTEND']?.length || 0"
            >
              <board-state-item
                v-for="(request, index) in requests.NEED_TO_EXTEND"
                :key="index"
                status="NEED_TO_EXTEND"
                :data="request"
              />
            </board-state>
          </li>
        </ul>
      </section>
      <section class="section">
        <h3 class="tit-h3">
          이슈 없음
        </h3>
        <el-table
          :data="requests.NON_ISSUE"
          :default-sort="{ prop: 'useStartDate', order: 'ascending' }"
          style="width: 100%"
        >
          <el-table-column
            label="자세히"
            width="60"
          >
            <template #default="scope">
              <el-button
                aria-label="자세히"
                @click="toRequestView(scope.row._id, 'NON_ISSUE')"
              >
                <font-awesome-icon icon="fa-regular fa-file-lines" />
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="companyName"
            label="회사명 / 계정"
            width="220"
            sortable
          >
            <template #default="scope">
              {{ scope.row.companyName }}<br/>
              {{ scope.row.userId }}
            </template>
          </el-table-column>
          <el-table-column
            prop="requestType"
            label="요청 유형"
            width="100"
            align="center"
            :filters="[
              { text: '플랜', value: 'PLAN' },
              { text: 'PV 충전', value: 'PV_CHARGE' },
              { text: 'Jam 충전', value: 'JAM_CHARGE' },
              { text: '부가 서비스', value: 'ADDITIONAL' }
            ]"
            :filter-method="filterHandler"
          >
            <template #default="scope">
              <status-tag 
                :color="getTagColor(scope.row.requestType)"
                size="small"
                :text="getRequestTypeValue(scope.row.requestType)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="useStartDate"
            label="사용 시작일"
            width="110"
            align="center"
            sortable
          />
          <el-table-column
            prop="useEndDate"
            label="사용 종료일"
            width="110"
            align="center"
            sortable
          >
            <template #default="scope">
              <template v-if="scope.row.useEndDate">
                {{ scope.row.useEndDate }}
              </template>
              <template v-else>
                -
              </template>
            </template>
          </el-table-column>
          <el-table-column
            prop="period"
            label="사용 기간"
            width="100"
            align="center"
            sortable
          >
            <template #default="scope">
              <status-tag
                v-if="scope.row.period"
                color="gray"
                size="small"
                :text="`${scope.row.period}개월`"
              />
              <template v-else>
                -
              </template>
            </template>
          </el-table-column>
          <el-table-column 
            prop="paymentType"
            label="결제 방식"
            width="100"
            align="center"
            :filters="[
              { text: '무통장', value: 'wire' },
              { text: '카드', value: 'card' },
              { text: '무상', value: 'free' }
            ]"
            :filter-method="filterHandler"
          >
            <template #default="scope">
              <status-tag 
                :color="getTagColor(scope.row.paymentType)"
                size="small"
                :text="getPaymentTypeValue(scope.row.paymentType)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="paymentDate"
            label="최초 결제일"
            width="110"
            align="center"
            sortable
          />
          <el-table-column
            label="발행 서류"
            width="120"
            align="center"
          >
            <template #default="scope">
              <template v-if="scope.row.docList.length > 0">
                <span 
                  v-for="(doc, index) in scope.row.docList"
                  :key="index"
                  class="center"
                >
                  {{ getDocumentTypeValue(doc) }}
                </span>
              </template>
              <template v-else>
                -
              </template>
            </template>
          </el-table-column>
          <el-table-column
            prop="firstDocDate"
            label="최초 서류 발행일"
            width="120"
            align="center"
          >
            <template #default="scope">
              <template v-if="scope.row.firstDocDate">
                {{ scope.row.firstDocDate }}
              </template>
              <template v-else>
                -
              </template>
            </template>
          </el-table-column>
          <el-table-column
            prop="memo"
            label="메모"
          >
            <template #default="scope">
              <template v-if="scope.row.memo">
                {{ scope.row.memo }}
              </template>
              <template v-else>
                -
              </template>
            </template>
          </el-table-column>
        </el-table>
      </section>
    </template>
    <template v-else-if="loading">
      <common-loader/>
    </template>
    <template v-else-if="isError && !loading">
      <CommonError message="서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.<br/> 문제가 지속되면 관리자에게 문의하세요."/>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from "vue"
import { useRouter } from "vue-router"
import { getBoardList } from "@/api"
import { getTagColor } from "@/utils"
import { getRequestTypeValue, getPaymentTypeValue, getDocumentTypeValue }  from '@/utils/getValueForKey'
import BoardState from '@/components/BoardState.vue'
import BoardStateItem from '@/components/BoardStateItem.vue'
import StatusTag from "@/components/StatusTag.vue"
import CommonLoader from '@/components/CommonLoader.vue'
import CommonError from '@/components/CommonError.vue'
import { RequestActiveStatusKeys } from '@/types/constants'
import { RequestOnBoard, RequestNonIssue } from "@/types/Request"
import type { TableColumnCtx } from 'element-plus';

type Requests = {
  [key in RequestActiveStatusKeys]: RequestOnBoard[];
} & {
  NON_ISSUE: RequestNonIssue[];
};

const requests = ref<Requests>({
  CREATED_REQUEST_PLAN: [],
  CREATED_REQUEST_PV: [],
  CREATED_REQUEST_JAM: [],
  CREATED_REQUEST_ADDITIONAL: [],
  DAY_PAYMENT_WIRE: [],
  DAY_PAYMENT_WIRE_DELAY: [],
  DAY_PAYMENT_CARD: [],
  DAY_INVOICE_TAX: [],
  DAY_INVOICE: [],
  NEED_TO_EXTEND: [],
  NON_ISSUE: []
});
const loading = ref<boolean>(false);
const isError = ref<boolean>(false);

const fetchData = async () => {
  loading.value = true;

  try {
    const response = await getBoardList();
    // console.log('Board Response', response.result);
    if(response.success) {
      const result: Requests = response.result;
      const filteredResult = {
        CREATED_REQUEST_PLAN: result.CREATED_REQUEST_PLAN,
        CREATED_REQUEST_PV: result.CREATED_REQUEST_PV,
        CREATED_REQUEST_JAM: result.CREATED_REQUEST_JAM,
        CREATED_REQUEST_ADDITIONAL: result.CREATED_REQUEST_ADDITIONAL,
        DAY_PAYMENT_WIRE: result.DAY_PAYMENT_WIRE,
        DAY_PAYMENT_WIRE_DELAY: result.DAY_PAYMENT_WIRE_DELAY,
        DAY_PAYMENT_CARD: result.DAY_PAYMENT_CARD,
        DAY_INVOICE_TAX: result.DAY_INVOICE_TAX,
        DAY_INVOICE: result.DAY_INVOICE,
        NEED_TO_EXTEND: result.NEED_TO_EXTEND,
        NON_ISSUE: result.NON_ISSUE,
      }
      requests.value = filteredResult;
    }
  } catch (error) {
    loading.value = false;
    isError.value = true;
    console.error('Error Message:', error);
  } finally {
    loading.value = false;
  }
}

// onMounted(fetchData);
fetchData();

const router = useRouter();
const toRequestView = (id: string, stat: string) => router.push({
  name: 'ViewStat',
  params: { id, stat }
});

const filterHandler = (
  value: string,
  row: RequestNonIssue,
  column: TableColumnCtx<RequestNonIssue>
) => {
  const property = column['property'] as keyof RequestNonIssue;
  return row[property] === value;
}
</script>